module.exports = __webpack_public_path__ + "img/esg_02.d4684777.jpg";